import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { API_ADMIN_TIPO_EVALUACION, URL_SUPPORT, ROW_COUNT } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import ITipoEvaluacion from "../../../entities/ITipoEvaluacion";
import AdminLista from "../AdminLista";

interface ITipoEvaluacionProps {
  cbTipoEvaluacion?: Array<ITipoEvaluacion>;
  is_test?: boolean;
}

const TipoEvaluacion = ({ cbTipoEvaluacion, is_test }: ITipoEvaluacionProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [comboVcc] = useState<Array<ITipoEvaluacion>>(cbTipoEvaluacion || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let params = { PAGINA: 1, PAGINADO: pageSize, ORDENADOPOR: "ID", ORIENTACION: "DESC", TITULO: null, ACTIVO: null };
    let result = is_test
      ? { data: [{}], pages: 10 }
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_EVALUACION}/getall`, { Authorization: `Bearer ${token}` }, params)).result;
    let list = result.data;
    setListItems(list);
    let pages = result.pages;
    setPages(pages);
    setIsLoading(false);
  }, [token]);

  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };
  const filter = (filter: any, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_EVALUACION}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        let pages = result.result.pages;
        setPages(pages);

        setListItems(result.result.data);
      })
      .catch((error) => {});
  };
  const edit = (value: any, filters: any) => {
    delete value.TRANSACTION_ID;
    if (value.ID === "") {
      delete value.ID;
    }
    postAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_EVALUACION}`, value, { Authorization: `Bearer ${token}` })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID > 0);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ID: "",
              ACTIVO: true,
              ID_ACTO: "1",
              ID_TIPO_CAUSA: 1,
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
              TIPO_CAUSA: "",
              TITULO: "",
            },
            {}
          );
          filter({});
          filter({ PAGINA: 1 });
          filter({ PAGINA: 1 }, true, 1);
          filter({ PAGINA: undefined }, false);
          paging(1);
        }}></button>
      <AdminLista
        reload={filter}
        items={[
          {
            type: "ID",
            value: comboVcc.map((vcc) => {
              return { text: vcc.TITULO, value: vcc.ID };
            }),
          },
        ]}
        callback={edit}
        data={listItems}
        tipo={"TipoEvaluacion"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Tipo Evaluación"
        hideAdd={true}
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default TipoEvaluacion;
